import { Drawer, VStack, HStack, Box, Icon, Text, Badge, Portal, CloseButton } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'
import { visibleModules } from '../../../modules/registry'
import { useProductTier } from '../../../hooks/useClientConfig'

interface ModulesSheetProps {
  isOpen: boolean
  onClose: () => void
}

export function ModulesSheet({ isOpen, onClose }: ModulesSheetProps) {
  const navigate = useNavigate()
  const tier = useProductTier()

  const go = (basePath: string) => {
    navigate(basePath)
    onClose()
  }

  return (
    <Drawer.Root placement='bottom' open={isOpen} onOpenChange={e => {
      if (!e.open) {
        onClose();
      }
    }}>
      <Portal>

        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content borderTopRadius="lg">
            <Drawer.CloseTrigger asChild><CloseButton size="sm" /></Drawer.CloseTrigger>
            <Drawer.Header>Modules</Drawer.Header>
            <Drawer.Body pb="env(safe-area-inset-bottom, 16px)">
              <VStack align="stretch" gap={2}>
                {visibleModules(tier).map((mod) => (
                  <HStack
                    gap={3}
                    p={3}
                    minH="44px"
                    borderRadius="md"
                    textAlign="left"
                    _hover={{ bg: 'gray.50' }}
                    _active={{ bg: 'gray.100' }}
                    asChild><button key={mod.id} onClick={() => go(mod.basePath)}>
                      <Box color="accent" flexShrink={0}>
                        <Icon boxSize={6} asChild><mod.icon /></Icon>
                      </Box>
                      <Box flex={1}>
                        <HStack gap={2}>
                          <Text fontWeight="semibold">{mod.label}</Text>
                          {mod.status === 'coming-soon' && (
                            <Badge colorPalette="purple" fontSize="0.6rem">Soon</Badge>
                          )}
                        </HStack>
                        <Text fontSize="sm" color="gray.500">{mod.description}</Text>
                      </Box>
                    </button></HStack>
                ))}
              </VStack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>

      </Portal>
    </Drawer.Root>
  );
}
